<template>
  <div>
    <div class="wechat-container">
      <Card title="基础信息">
        <a-form-model
          class="ant-advanced-search-form"
          :model="siteForm"
          layout="horizontal"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 18, offset: 1 }"
          :rules="rules"
          ref="form"
        >
          <div class="form-container">
            <a-form-model-item label="站点类型" required>
              <a-input disabled v-model="siteForm.spiderClassType" size="large" />
            </a-form-model-item>

            <a-form-model-item label="国家" required prop="countryCode">
              <CountrySelect v-model="siteForm.countryCode" size="large" disabled />
            </a-form-model-item>

            <a-form-model-item label="用户ID" required prop="accountId">
              <a-space>
                <a-input v-model="siteForm.accountId" size="large" />
                <a-popover trigger="click">
                  <a-space slot="content">
                    <a-input
                      :style="{ width: '300px' }"
                      v-model="accountUrl"
                      placeholder="请输入微信公众号地址"
                    ></a-input>
                    <a-button type="primary" @click="execAccountUrl" :loading="accountLoading"
                      >解析</a-button
                    >
                  </a-space>

                  <a-button size="large" type="primary">获取</a-button>
                </a-popover>
              </a-space>
            </a-form-model-item>

            <a-form-model-item label="语言" required prop="langCode">
              <LangSelect v-model="siteForm.langCode" size="large" disabled />
            </a-form-model-item>

            <a-form-model-item label="用户名称" required prop="accountName">
              <a-input v-model="siteForm.accountName" size="large" />
            </a-form-model-item>

            <a-form-model-item label="账号描述" required prop="accountDesc">
              <a-textarea v-model="siteForm.accountDesc" size="large" />
            </a-form-model-item>

            <a-form-model-item label="IP代理">
              <a-radio-group button-style="solid" v-model="siteForm.ipConfig.enabled">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              v-if="siteForm.ipConfig.enabled == 1"
              label="代理国家"
              :prop="Boolean(siteForm.ipConfig.enabled) ? 'ipConfigCountry' : ''"
            >
              <CountrySelect v-model="siteForm.ipConfigCountry" />
            </a-form-model-item>

            <a-form-model-item
              v-if="siteForm.ipConfig.enabled == 1"
              label="代理数量"
              :prop="Boolean(siteForm.ipConfig.enabled) ? 'ipConfigNum' : ''"
            >
              <a-input-number
                v-model="siteForm.ipConfigNum"
                style="width: 100%"
                placeholder="请输入IP代理数量"
              />
            </a-form-model-item>

            <a-form-model-item label="标签设置" prop="spiderTags">
              <div class="tags-inner">
                <Tag
                  v-for="(tag, index) in siteForm.spiderTags"
                  :onDelete="() => onSelectTag(tag)"
                  :key="index"
                >
                  <a-tooltip :title="tag.spiderTagName" :delay="1000">
                    {{ tag.spiderTagName }}
                  </a-tooltip>
                </Tag>
                <div class="add-tag" @click="isShowTagSelectorModal = true">+ 添加标签</div>
              </div>
            </a-form-model-item>
          </div>
        </a-form-model>
      </Card>

      <a-modal
        title="选择标签"
        :visible="isShowTagSelectorModal"
        okText="确定"
        cancelText="取消"
        :closable="false"
        @cancel="isShowTagSelectorModal = false"
        @ok="isShowTagSelectorModal = false"
        :width="725"
      >
        <div class="tags-modal-contianer">
          <div class="tabs-operation">
            <a-button type="primary" icon="plus" @click="handleTagAdd">新增</a-button>
          </div>

          <a-tree
            checkable
            :defaultExpandAll="true"
            :checkStrictly="true"
            :checkedKeys="siteForm.spiderTags.map((t) => t.spiderTagId)"
            @check="onUpdateCheckedKeys"
          >
            <a-tree-node v-for="item in labels" :key="item.spiderTagId" :value="item.spiderTagId">
              <div class="node-title" slot="title">
                <span @click.stop="handTagCheck(item)">{{ item.title }}</span>
                <a-icon type="edit" class="icon" @click.stop="handTagEdit(item)" />

                <a-popconfirm title="确定要删除吗?" @confirm="() => handTagDelete(item)">
                  <a-icon type="delete" class="icon" />
                </a-popconfirm>
              </div>
              <a-tree-node v-for="i in item.children" :key="i.spiderTagId" :value="i.spiderTagId">
                <div class="node-title" slot="title">
                  <span @click.stop="handTagCheck(i)">{{ i.title }}</span>
                  <a-icon type="edit" class="icon" @click.stop="handTagEdit(i)" />

                  <a-popconfirm title="确定要删除吗?" @confirm="() => handTagDelete(i)">
                    <a-icon type="delete" class="icon" />
                  </a-popconfirm>
                </div>
              </a-tree-node>
            </a-tree-node>
          </a-tree>
        </div>
      </a-modal>
    </div>

    <div class="xpath-container">
      <Card title="解析规则">
        <a-form-model :model="spiderParse">
          <a-form-model-item label="选择器类型">
            <a-radio-group v-model="spiderParse.spiderParseType">
              <a-radio :value="4"> 智能解析 </a-radio>
              <a-radio :value="1"> xpath解析器 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="解析规则">
            <a-card
              class="config-card"
              v-for="(item, index) in spiderParse.spiderParseConfigs"
              :key="index"
            >
              <div slot="extra" class="card-operate">
                <span @click="handleCopyConfig(item, index)">复制</span>
              </div>
              <Rule :ruleForm="item" />
            </a-card>
          </a-form-model-item>
        </a-form-model>
      </Card>

      <div class="bts-container">
        <a-button
          size="large"
          :style="{ width: '100px', display: 'block', marginBottom: '12px' }"
          @click="back()"
          v-if="editId"
          >返回</a-button
        >

        <a-button
          size="large"
          :style="{ width: '100px', display: 'block', marginBottom: '12px' }"
          @click="showParseHtml = true"
          >测试</a-button
        >

        <a-button
          type="primary"
          size="large"
          :style="{ width: '100px' }"
          :loading="loading"
          @click="submit"
          >{{ editId ? '修改' : '创建' }}</a-button
        >
      </div>

      <a-modal
        width="1000px"
        v-model="showParseHtml"
        :footer="null"
        title="测试结果"
        @cancel="handleCancel"
      >
        <a-input-search
          v-model="url"
          placeholder="请输入需要测试的URL"
          enter-button="执行"
          @search="handleTest"
          :loading="parseLoading"
        />
        <h1 class="center test-title">{{ parseHtml.title }}</h1>
        <p v-if="parseHtml.author || parseHtml.publish_time" class="center author">
          <span>作者：</span>{{ parseHtml.publisher }}
          <span style="margin-left: 20px">发布时间：</span>{{ parseHtml.publish_time }}
        </p>
        <div v-if="parseHtml.abstract">
          <p class="test-key">摘要：</p>
        </div>
        <p v-if="parseHtml.keyword"><span class="test-key">关键字：</span></p>
        <template v-for="item in parseHtml.content_list">
          <p class="center" v-if="item['img']">
            <img style="max-width: 100%" :src="item.img" :alt="item.alt" />
            <span>{{ item.alt }}</span>
          </p>
          <p v-else class="test-content" v-text="item['p']"></p>
        </template>

        <div v-if="parseHtml.files_info">
          <p class="test-key">文件列表：</p>
          <p class="test-content file-url" v-for="file in parseHtml.files_info">
            {{ file.img }}
          </p>
        </div>
      </a-modal>
    </div>

    <a-drawer
      :title="createAndUpdateData == null ? '新增标签' : '修改标签'"
      width="600"
      :closable="true"
      :visible="createAndUpdateShow"
      @close="createAndUpdateShow = false"
    >
      <TagForm
        v-if="createAndUpdateShow"
        ref="form"
        :formModel="createAndUpdateData"
        :roots="labels"
        @refresh="handleRefresh"
      />
    </a-drawer>
  </div>
</template>

<script>
import Card from '../components/Card'
import CountrySelect from '@/components/CountrySelect/'
import LangSelect from '@/components/LangSelect/'
import SelectTag from '@/components/SelectTag2/'
import TagForm from '../components/TagForm.vue'
import {
  queryTagListApi,
  getSpiderApiByIdApi,
  updateSpiderApiItemApi,
  execAccountUrlApi,
  testSpiderApi
} from '@/api/Site/Create'
import { deleteTagApi } from '@/api/System/Tags'
import { onHttpResponseSilent } from '@/utils/request'
import Tag from '../components/Tag'

import { addSpiderApiItem } from '@/api/Site/Create'
import { onHttpResponse } from '../../../../utils/request'

import Rule from './Rule'
import _ from 'lodash'

export default {
  components: { Card, CountrySelect, LangSelect, SelectTag, Tag, Rule, TagForm },

  props: {
    onSubmited: {
      type: Function
    }
  },

  data() {
    return {
      siteForm: {
        spiderId: '',
        spiderClassId: '',
        spiderName: '',
        spiderClassType: 'wechat',
        accountId: '',
        accountName: '',
        accountDesc: '',
        countryCode: 'cn',
        langCode: 'zh',
        spiderLevel: 2,
        deployType: 0,
        spiderExecTimeType: 3,
        spiderExecTimeCycle: 1,
        execType: null,
        spiderTags: [],
        ipConfig: {
          enabled: 0
        },
        // 下面配置项不知道是啥
        // 上面的其实也不知道
        whiteConfig: {
          hosts: [],
          path: []
        },
        blackConfig: {
          hosts: [],
          path: []
        },
        spiderUrls: ['https://mp.weixin.qq.com/'],
        synNum: 1 // 线程数
      },
      spiderParse: {
        spiderParseType: 4,
        spiderParseConfigs: [
          {
            urls: [''],
            parseId: 'wechat_parse_id',
            spiderConfigs: [
              {
                name: 'title',
                rule: '//h1/text()'
              },
              {
                name: 'content',
                rule: ''
              },
              {
                name: 'publisher',
                rule: "//*[@id='js_profile_qrcode']/div/strong/text()"
              },
              {
                name: 'publish_time',
                rule: ''
              },
              {
                name: 'keywords',
                rule: ''
              },
              {
                name: 'file',
                rule: ''
              },
              {
                name: 'description',
                rule: ''
              }
            ]
          }
        ]
      },
      rules: {
        countryCode: [{ required: true, message: '国家必填', trigger: 'change' }],
        langCode: [{ required: true, message: '语言必填', trigger: 'change' }],
        accountId: [{ required: true, message: '用户ID必填', trigger: 'blur' }],
        accountName: [{ required: true, message: '用户名称必填', trigger: 'blur' }],
        spiderName: [{ required: true, message: '站点名称必填', trigger: 'change' }],
        accountDesc: [{ required: true, message: '账号描述必填', trigger: 'blur' }],
        ipConfigCountry: [{ required: true, message: '代理国家必填', trigger: 'change' }],
        ipConfigNum: [{ required: true, message: '代理数量必填', trigger: 'blur' }],
        // spiderExecTimeCycle: {
        //   required: true,
        //   type: 'number',
        //   asyncValidator: (_, value) => {
        //     return new Promise((resolve, reject) => {
        //       if (value >= 1 && value <= this.max) {
        //         resolve()
        //       } else {
        //         reject('时间周期不合法')
        //       }
        //     })
        //   },
        //   trigger: 'blur'
        // }

        spiderTags: [
          {
            type: 'array',
            required: true,
            message: '标签至少选择一个',
            trigger: 'change'
          }
        ]
      },

      originLabels: [],
      labels: [],
      isShowTagSelectorModal: false,

      loading: false,

      editId: undefined,

      accountUrl: '', // 用来解析出用户id
      accountLoading: false,
      parseHtml: {},
      cancel: null,
      showParseHtml: false,
      parseLoading: false,
      url: null,

      testSiteForm: {
        spider: {
          spiderId: '',
          spiderClassId: '',
          spiderName: '',
          spiderUrl: [],
          country: 'cn',
          spiderLevel: 2,
          deployType: 0,
          codeType: 'page',
          lang: 'zh',
          browser: 'false',
          spiderExecTimeType: 1,
          spiderExecTimeCycle: 10,
          whiteConfig: {
            hosts: [],
            paths: []
          },
          blackConfig: {
            hosts: [],
            paths: []
          },
          spiderTags: [],
          timeOut: 10000,
          retryNum: 3,
          synCycle: 0,
          synNum: 32,
          ipConfig: {
            enabled: 0
            // url: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=cn'
          },
          ipConfigNum: 0,
          ipConfigCountry: ''
        },
        parse: {
          spiderParseType: 4,
          spiderParseConfig: [
            {
              urls: [''],
              parseId: 'sputniknews_document_parse_id',
              config: [
                { name: 'title', rule: '' },
                { name: 'content', rule: '' },
                { name: 'publisher', rule: '' },
                { name: 'publish_time', rule: '' },
                { name: 'keywords', rule: '' },
                { name: 'file', rule: '' },
                { name: 'origin', rule: '' },
                { name: 'description', rule: '' }
              ]
            }
          ]
        },
        url: null
      },

      createAndUpdateData: null,
      createAndUpdateShow: false
    }
  },

  computed: {
    max() {
      let { spiderExecTimeType } = this.siteForm
      let max = 0
      if (spiderExecTimeType == 0 || spiderExecTimeType == 1) {
        max = 59
      } else if (spiderExecTimeType == 2) {
        return 23
      } else if (spiderExecTimeType == 3) {
        max = 31
      } else {
        max = 12
      }
      return max
    }
  },

  mounted() {
    this.getLabels()

    const { spiderClassId } = this.$route.query
    if (spiderClassId) {
      this.siteForm.spiderClassId = spiderClassId
    }

    let { spiderId } = this.$route.query
    if (spiderId) {
      // 这是修改
      this.getSpiderById(spiderId)
      this.editId = spiderId
    }
  },

  methods: {
    back() {
      sessionStorage.types = 'others'
      this.$router.back(-1)
    },
    getLabels() {
      queryTagListApi({})
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.originLabels = [...data]
          data = data.map((d) => ({
            ...d,
            title: d.spiderTagName,
            key: d.spiderTagId
          }))
          this.labels = data
            .filter((d) => d.parentId === -1)
            .map((d) => ({
              ...d,
              children: []
            }))
          data.forEach((d) => {
            const root = this.labels.find((r) => r.spiderTagId === d.parentId)
            if (root) {
              root.children.push(d)
            }
          })
        })
    },

    onSelectTag(tag) {
      if (this.siteForm.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)) {
        this.siteForm.spiderTags = this.siteForm.spiderTags.filter(
          (t) => t.spiderTagId !== tag.spiderTagId
        )
      } else {
        this.siteForm.spiderTags.push(tag)
      }

      this.$refs.ruleForm.validateField('spiderTags')
    },

    getPostData(runNow) {
      return {
        ...this.siteForm,
        spiderName: this.siteForm.accountName,
        mqConfig: window.spider.default.mqConfig,
        execType: runNow ? 1 : 0,
        spiderParse: this.spiderParse
      }
    },

    handleCancel() {
      this.showParseHtml = false
      this.parseHtml = {
        files: [],
        content: ''
      }
    },

    async handleTest() {
      if (this.url.trim() == '') {
        this.$message.error('url不能为空!')
        return
      }
      this.createTestSiteForm(this.url)
      testSpiderApi(this.testSiteForm)
        .then(onHttpResponse)
        .then((res) => {
          let { extra } = res
          this.parseHtml = extra.parseHtml
          this.showParseHtml = true
        })
        .finally(() => {
          this.parseLoading = false
        })
    },

    createTestSiteForm(url) {
      let tempForm = JSON.parse(JSON.stringify(this.siteForm))
      let tempParse = JSON.parse(JSON.stringify(this.spiderParse))
      this.testSiteForm.spider.spiderId = 'spider_wechat_test'
      this.testSiteForm.spider.spiderClassId = tempForm.spiderClassId
      this.testSiteForm.spider.spiderName = '测试解析'
      this.testSiteForm.spider.spiderUrls = tempForm.spiderUrls
      this.testSiteForm.spider.countryCode = tempForm.countryCode
      this.testSiteForm.spider.spiderLevel = tempForm.spiderLevel
      this.testSiteForm.spider.deployType = tempForm.deployType
      this.testSiteForm.spider.langCode = tempForm.langCode
      this.testSiteForm.spider.spiderExecTimeType = tempForm.spiderExecTimeType
      this.testSiteForm.spider.spiderExecTimeCycle = tempForm.spiderExecTimeCycle
      this.testSiteForm.spider.whiteConfig = tempForm.whiteConfig
      this.testSiteForm.spider.blackConfig = tempForm.blackConfig
      this.testSiteForm.spider.timeOut = 1000
      this.testSiteForm.spider.retryNum = 1
      this.testSiteForm.spider.synCycle = 1
      this.testSiteForm.spider.synNum = 1
      this.testSiteForm.spider.ipConfig = tempForm.ipConfig
      this.testSiteForm.spider.ipConfigNum = 1
      this.testSiteForm.spider.ipConfigCountry = 'cn'
      this.testSiteForm.spider.spiderUrl = tempForm.spiderUrls
      this.testSiteForm.spider.bro

      this.testSiteForm.spider.country = '中国'

      this.testSiteForm.parse.spiderParseType = tempParse.spiderParseType
      this.testSiteForm.parse.spiderParseConfig = tempParse.spiderParseConfigs
      this.testSiteForm.parse.spiderParseConfig.forEach((data) => {
        data['config'] = data['spiderConfigs']
        data['spiderConfigs'] = null
      })

      this.testSiteForm.url = url
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject()
          }
        })
      })
    },

    async getSpiderById() {
      await getSpiderApiByIdApi({ spiderId: this.$route.query.spiderId })
        .then(onHttpResponseSilent)
        .then(({ code, extra }) => {
          if (code === 200) {
            this.siteForm = Object.assign(this.siteForm, extra.data)

            this.spiderParse = {
              spiderParseType: extra.data.spiderParse.spiderParseType,
              spiderParseConfigs: extra.data.spiderParse.spiderParseConfigs
            }
          }
        })
    },

    reset() {
      if (this.editId) {
        let { spiderId } = this.$route.query
        this.getSpiderById(spiderId)
      } else {
        this.siteForm.countryCode = 'cn'
        this.siteForm.langCode = 'zh'
        this.siteForm.accountId = ''
        this.siteForm.accountName = ''
        this.siteForm.spiderExecTimeType = 3
        this.siteForm.spiderExecTimeCycle = 1
        this.siteForm.accountDesc = ''
        this.siteForm.spiderTags = []
      }
    },

    submit() {
      this.validateForm()
        .then(() => {
          if (this.editId) {
            this.updateSpiderItem()
          } else {
            this.addSpiderItem()
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },

    async addSpiderItem() {
      this._addSpiderItem(false)
    },

    async updateSpiderItem() {
      this.loading = true

      let postData = this.getPostData()
      delete postData.execType
      updateSpiderApiItemApi(postData)
        .then(onHttpResponseSilent)
        .then(() => {
          if (this.onSubmited) {
            this.onSubmited(res)
          } else {
            // this.$router.push({
            //   name: 'site_approval_list',
            //   query: { type: 'wechat' }
            // })

            this.$router.push({
              name: this.$route.query.route,
              query: { type: this.$route.query.type }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    async _addSpiderItem(runNow) {
      this.loading = true
      let postData = this.getPostData(runNow)
      return addSpiderApiItem(postData)
        .then(onHttpResponse)
        .then(() => {
          this.$router.push({
            name: 'site_approval_list',
            query: { type: 'wechat' }
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    execAccountUrl() {
      if (this.accountLoading) {
        return
      }
      this.accountLoading = true
      execAccountUrlApi({
        url: this.accountUrl
      })
        .then(({ extra }) => {
          this.siteForm.accountId = extra.id
        })
        .finally(() => {
          this.accountLoading = false
        })
    },

    handleCopyConfig(val, index) {
      this.spiderParse.spiderParseConfigs.splice(index, 0, _.cloneDeep(val))
    },

    onUpdateCheckedKeys(tags) {
      const checked = tags.checked
      this.siteForm.spiderTags = this.originLabels.filter((d) => checked.includes(d.spiderTagId))
    },

    handleRefresh() {
      this.createAndUpdateShow = false
      this.getLabels()
    },

    handleTagAdd() {
      this.createAndUpdateData = null
      this.createAndUpdateShow = true
    },

    // 手动点击文字的时候进行标签选中：
    handTagCheck(val) {
      if (this.siteForm.spiderTags.map((t) => t.spiderTagId).includes(val.spiderTagId)) {
        this.siteForm.spiderTags = this.siteForm.spiderTags.filter(
          (t) => t.spiderTagId !== val.spiderTagId
        )
      } else {
        this.siteForm.spiderTags.push(val)
      }
    },

    handTagEdit(val) {
      this.createAndUpdateData = { ...val }
      this.createAndUpdateShow = true
    },

    async handTagDelete(val) {
      const res = await deleteTagApi(val.spiderTagId)
      let { code, msg } = res
      if (code === 200) {
        this.getLabels()
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wechat-container {
  width: calc(100% - 200px);
  position: relative;

  .form-container {
    width: 100%;
    display: grid;
    grid-template-columns: 45% 45%;
    gap: 0 60px;

    .tags-inner {
      display: grid;
      grid-template-columns: repeat(auto-fill, 86px);
      gap: 10px;

      .add-tag {
        width: 100%;
        height: 36px;
        border-radius: 4px;
        background: #1990ff;
        color: white;
        border: none;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.xpath-container {
  width: calc(100% - 200px);
  position: relative;
  margin-top: 24px;
}

.bts-container {
  position: absolute;
  right: -180px;
  bottom: 0px;
}

.tags-modal-contianer {
  &::v-deep .ant-tree li .ant-tree-node-content-wrapper:hover {
    background: none;
  }
  &::v-deep .ant-tree li .ant-tree-node-content-wrapper {
    .node-title {
      display: flex;
      align-items: center;

      .icon {
        font-size: 12px;
        margin-left: 8px;
      }
      .icon:hover,
      span:hover {
        color: #1890ff;
      }
    }
  }

  &::v-deep .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: none;
  }
}

.atag:hover {
  background: #3c93ff;
  color: #fff;
}

.card-operate {
  span {
    margin-left: 20px;
    font-size: 14px;
    cursor: pointer;
    color: #1890ff;
  }
}

.center {
  text-align: center;
}
.test-title {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  margin: 20px 0;
}
.author {
  color: #999;
}
.test-content {
  color: #666;
  margin-bottom: 0;
  line-height: 30px;
  font-size: 12px;
}
.test-key {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
}
.file-url {
  color: #4683ff;
}
</style>
